export default {
  getUserGroups: {
    server: '/user-groups',
    method: 'get',
  },
  addUserGroup: {
    server: '/user-groups',
    method: 'post',
  },
  putUserGroup: {
    server: '/user-groups/{userGroupId}',
    method: 'put',
  },
  deleteUserGroup: {
    server: '/user-groups/{userGroupId}',
    method: 'delete',
  },
  getUserGroupRoles: {
    server: '/user-groups/{userGroupId}/roles',
    method: 'get',
  },
  getUserGroupUsers: {
    server: '/user-groups/{userGroupId}/users',
    method: 'get',
  },
};
